<template>
    <nav aria-label="Page navigation example ">
        <ul class="pagination justify-content-center" style="margin:5px;">
            <slot>
            </slot>            
        </ul>
        </nav>
</template>

<script>
export default {

}
</script>

<style>
    .page-item.active .page-link{
        background: #1c4d5a;
        border: 1px solid #fff;
        border-radius: 25px!important;

    }
</style>